const ar = {
    title: 'SketchScope: Augmented Reality',
    about: 'SketchScope의 기능을 증강현실(Augmented Reality)에서도 사용할 수 있습니다. \n' +
'지정된 손동작을 통해서 각각의 모드를 사용할 수 있으며, 손동작에 대한 설명은 상단의 Motion Recognition 탭에서 확인할 수 있습니다.\n' +
'QR 코드를 인식하면 그 위에 결과를 시각화하는 기능을 추가하여, 원하는 위치에서 SketchScope을 작동할 수 있도록 하였습니다.',
    interface: '미정',
    hololense: 'HoloLens2를 활용하여 AR 환경에서 SketchScope을 활용하는 영상을 확인할 수 있습니다. \n',
    demo: "@/assets/sketchscope.png"
}

export {ar}